import { CommonModule, NgIf } from '@angular/common'
import { Component } from '@angular/core'
import { FormMarketingDeskComponent } from './form-marketing-desk/form-marketing-desk.component'
import { HeaderComponent } from './header/header.component'
import { HomeMarketingDeskComponent } from './home-marketing-desk/home-marketing-desk.component'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { SRECSuccessComponent } from './success-marketing-desk/success-marketing-desk.component'
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component'
import { RegisterSrecComponent } from './register-srec/register-srec.component'
import { RegisterSrecCommercialComponent } from './register-srec-commercial/register-srec-commercial.component'

@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    imports: [
        ReactiveFormsModule,
        CommonModule,
        NgIf,
        HomeMarketingDeskComponent,
        FormMarketingDeskComponent,
        RouterModule,
        HeaderComponent,
        SRECSuccessComponent,
        TermsOfServiceComponent,
        RegisterSrecComponent,
        RegisterSrecCommercialComponent
    ],
})
export class AppComponent {}
